<script setup>
import VehicleCell from "./VehicleCell.vue";
import ConnectorCellPicker from "./ConnectorCellPicker.vue";
import { FormInputType } from "../../../../interfaces/input";
defineProps({
  vehicle: {
    type: Object,
    required: true
  },
  connector: {
    type: Object,
    required: true
  },
  legacyApiUrl: {
    type: String,
    required: true
  },
  hasTimeInput: {
    type: Boolean,
    default: false
  }
});
defineEmits(["selectVehicle", "selectConnector"]);
const timeValue = defineModel({ type: String, ...{
  default: ""
} });
</script>

<template>
    <div class="flex flex-col rounded-lg border border-gray-disabled">
        <VehicleCell :vehicle @selectVehicle="$emit('selectVehicle', $event)" />
        <div class="ml-4 md:ml-0 h-px border-b border-gray-disabled" />
        <ConnectorCellPicker
            :connector
            :legacyApiUrl
            @selectConnector="
  ($event2) => $emit('selectConnector', $event2)
"
        />
        <div v-if="hasTimeInput" class="flex flex-col w-full">
            <div class="ml-4 h-px border-b border-gray-disabled" />
            <ChargemapFormInput
                v-model="timeValue"
                :type="FormInputType.TIME"
                :label="$t('simulation.charge.user_settings.time')"
            >
                <IconClock class="size-5" />
            </ChargemapFormInput>
        </div>
    </div>
</template>
